import React, { useMemo } from 'react';

import FormControl from '@material-ui/core/FormControl';
import MuiSelect from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import useStyles from '../../../styles/selectStyle';

const DefaultItem = {
  title: '-- Choose --',
  value: -1,
  label: '-- Choose --',
  id: '-- Choose --'
};

export const Select = ({
  variant = 'outlined',
  labelId = 'select',
  id = '',
  value = -1,
  onChange: handleChange,
  items = [],
  disabled = false,
  readOnly = false,
  error = false,
}) => {
  const classes = useStyles();

  const menuItems = useMemo(() => {
    if (typeof items !== "object") {
      return [DefaultItem];
    }

    if (!items?.length) {
      return [DefaultItem];
    }

    const nextItems = [DefaultItem, ...items];
    return nextItems;
  }, [items]);

  return (
    <FormControl variant={variant} className={`input ${error ? 'error' : ''} ${classes.formControl}`}>
      <MuiSelect
        labelId={labelId}
        id={id}
        MenuProps={{ classes: { paper: classes.paper, list: classes.list } }}
        classes={{ outlined: classes.outlined}}
        value={value}
        readOnly={readOnly}
        onChange={handleChange}
        disabled={disabled}
      >
        {
          menuItems.map(({
            title = '',
            value,
            label = '',
            id = ''
          }) => (
            <MenuItem
              title={title}
              classes={{ selected: classes.selected }}
              className={classes.root}
              value={value}
              key={id}
            >
              {label}
            </MenuItem>
          ))
        }
      </MuiSelect>
    </FormControl>
  );
};

export default Select;
